import React from 'react';
export function Footer() {
  return <footer className="bg-[#3d4f5c] text-white py-12 border-t border-white/10" data-id="element-71">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-73">
          <div className="flex items-center gap-3" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/r2Qpm7TVH9yfhMg7exMXJN/IMG_2424.png" alt="Fix & Finish Logo" className="h-10 w-auto brightness-0 invert" data-id="element-75" />
            <div className="flex flex-col" data-id="element-76">
              <span className="text-lg font-bold leading-none" data-id="element-77">
                FIX & FINISH
              </span>
              <span className="text-[10px] font-medium tracking-wider text-gray-400" data-id="element-78">
                PDX CONTRACTING
              </span>
            </div>
          </div>

          <div className="flex gap-8 text-sm text-gray-300" data-id="element-79">
            <a href="#services" className="hover:text-white transition-colors" data-id="element-80">
              Services
            </a>
            <a href="#why-us" className="hover:text-white transition-colors" data-id="element-81">
              About
            </a>
            <a href="#contact" className="hover:text-white transition-colors" data-id="element-82">
              Contact
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-83">
              Privacy
            </a>
          </div>

          <div className="text-sm text-gray-400" data-id="element-84">
            © {new Date().getFullYear()} Fix & Finish PDX. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}